export default "__VITE_ASSET__D0Y2nt91__"